<template>
    <div>
        <!-- Price Range Section -->
        <div class="mt-4">
            <div @click="togglePriceState" class=" cursor-pointer flex items-center justify-between transition-height-transform  duration-200 delay-300 ">
                <div class="flex flex-col gap-2 flex-1">
                    <span class=" font-semibold">{{ $t('search.price') }}</span>
                    <!-- Display selected prices -->
                    <div v-if="selectedPrices.length > 0" class="flex flex-wrap gap-2 mt-2">
                        <div 
                            v-for="selectedPrice in selectedPrices" 
                            :key="selectedPrice.id"
                            class="flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-lg px-3 py-1.5 text-sm hover:bg-primary/15 transition-colors duration-200 group"
                        >
                            <!-- Price name -->
                            <span class="text-primary font-medium text-xs">
                                {{ selectedPrice.name }}
                            </span>
                            
                            <!-- Remove button -->
                            <button 
                                @click.stop="removePriceRange"
                                class="ml-1 text-gray-400 hover:text-red-500 transition-colors duration-200 p-0.5 rounded-full hover:bg-red-50 group-hover:bg-red-50"
                                :title="$t('general.remove')"
                            >
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <span 
                    class="w-8 h-8 flex items-center justify-center cursor-pointer">
                    <img :class="` ${!priceDropdownOpen ? ' rotate-90 ' : ' rotate-0 '} transition-height-transform  cursor-pointer`"
                        src="../../assets/icons/down.svg" alt="">
                </span>
            </div>
            <div
                :class="`${!priceDropdownOpen ? 'min-h-[0px]' : 'min-h-[20px]'} transition-height-transform  text-[14px] text-[#484848BD]`">
                <div :class="`  ${priceDropdownOpen ? 'flex' : 'hidden'}  flex flex-col gap-1 text-[14px] mt-3`">

                    <form @submit.prevent="submitPriceRange" class="flex items-center gap-3 ">
                        <input
                            :class="`border  rounded-md w-[100px] text-[14px] ${localPrice.min_price.val && (localPrice.min_price.val > localPrice.max_price.val) ? ' border-red-600' : 'border-[#C6C6C6]'}`"
                            :placeholder="$t('search.min')" v-model="localPrice.min_price.val" type="number" name=""
                            id="" min="0">
                        <span>{{ $t('search.to') }}</span>
                        <input
                            :class="`border  rounded-md w-[100px] text-[14px] ${(localPrice.min_price.val && !localPrice.max_price.val) || (localPrice.min_price.val > localPrice.max_price.val) ? ' border-red-600' : 'border-[#C6C6C6]'}`"
                            :placeholder="$t('search.max')" v-model="localPrice.max_price.val" type="number" name=""
                            id="" :min="localPrice.min_price.val">
                        <button
                            class=" h-[42px] w-[50px] rounded-md  flex items-center justify-center bg-primary">
                            <img src="../../assets/icons/check_white.svg" alt="">
                        </button>
                    </form>
                    <p v-if="localPrice.isErr" class="text-red-600 mt-1 text-center"> {{ $t('search.price_err') }}
                    </p>
                    <div class="text-[14px] mt-4 text-black">
                        <Toggler @toggleTogglar="(name, val) => updateNegotiable(val)" fontSize="12px" :val="isNegotiable"
                            name="agreedProducts" :title="$t('search.show_agreed_products')" />
                    </div>
                </div>
            </div>

        </div>
        
        <!-- Space Range Section (conditional) -->
        <div v-if="showSpaces" class="mt-4">
            <div @click="toggleSpacesState" class=" cursor-pointer flex items-center justify-between transition-height-transform  duration-200 delay-300 ">
                <div class="flex flex-col gap-2 flex-1">
                    <span class=" font-semibold">{{ $t('search.spaces') }}</span>
                    <!-- Display selected spaces -->
                    <div v-if="selectedSpaces.length > 0" class="flex flex-wrap gap-2 mt-2">
                        <div 
                            v-for="selectedSpace in selectedSpaces" 
                            :key="selectedSpace.id"
                            class="flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-lg px-3 py-1.5 text-sm hover:bg-primary/15 transition-colors duration-200 group"
                        >
                            <!-- Space name -->
                            <span class="text-primary font-medium text-xs">
                                {{ selectedSpace.name }}
                            </span>
                            
                            <!-- Remove button -->
                            <button 
                                @click.stop="removeSpaceRange"
                                class="ml-1 text-gray-400 hover:text-red-500 transition-colors duration-200 p-0.5 rounded-full hover:bg-red-50 group-hover:bg-red-50"
                                :title="$t('general.remove')"
                            >
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <span 
                    class="w-8 h-8 flex items-center justify-center cursor-pointer">
                    <img :class="` ${!spacesDropdownOpen ? ' rotate-90 ' : ' rotate-0 '} transition-height-transform  cursor-pointer`"
                        src="../../assets/icons/down.svg" alt="">
                </span>
            </div>
            <div
                :class="`${!spacesDropdownOpen ? 'min-h-[0px]' : 'min-h-[20px]'} transition-height-transform  text-[14px] text-[#484848BD]`">
                <div :class="`  ${spacesDropdownOpen ? 'flex' : 'hidden'}  flex flex-col gap-1 text-[14px] mt-3`">

                    <form @submit.prevent="submitSpaceRange" class="flex items-center gap-3 ">
                        <input
                            :class="`border  rounded-md w-[100px] text-[14px] ${localSpaces.min_space.val && (localSpaces.min_space.val > localSpaces.max_space.val) ? ' border-red-600' : 'border-[#C6C6C6]'}`"
                            :placeholder="$t('search.min_space')" v-model="localSpaces.min_space.val" type="number" name=""
                            id="" min="0">
                        <span>{{ $t('search.to') }}</span>
                        <input
                            :class="`border  rounded-md w-[100px] text-[14px] ${(localSpaces.min_space.val && !localSpaces.max_space.val) || (localSpaces.min_space.val > localSpaces.max_space.val) ? ' border-red-600' : 'border-[#C6C6C6]'}`"
                            :placeholder="$t('search.max_space')" v-model="localSpaces.max_space.val" type="number" name=""
                            id="" :min="localSpaces.min_space.val">
                        <button
                            class=" h-[42px] w-[50px] rounded-md  flex items-center justify-center bg-primary">
                            <img src="../../assets/icons/check_white.svg" alt="">
                        </button>
                    </form>
                    <p v-if="localSpaces.isErr" class="text-red-600 mt-1 text-center"> {{ $t('search.spaces_err') }}
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Toggler from './Toggler.vue'

export default {
    name: 'FilterRanges',
    components: {
        Toggler
    },
    props: {
        priceState: {
            type: Object,
            required: true
        },
        spacesState: {
            type: Object,
            required: true
        },
        showSpaces: {
            type: Boolean,
            default: false
        },
        isNegotiable: {
            type: Boolean,
            default: true
        },
        minPrice: {
            type: [Number, String],
            default: null
        },
        maxPrice: {
            type: [Number, String],
            default: null
        },
        minSpace: {
            type: [Number, String],
            default: null
        },
        maxSpace: {
            type: [Number, String],
            default: null
        }
    },
    emits: ['price-submitted', 'spaces-submitted', 'negotiable-changed', 'remove-price', 'remove-space'],
    data() {
        return {
            priceDropdownOpen: false,
            spacesDropdownOpen: false,
            localPrice: { ...this.priceState },
            localSpaces: { ...this.spacesState }
        }
    },
    computed: {
        selectedPrices() {
            const selectedPrices = []
            
            if (this.minPrice || this.maxPrice) {
                let priceText = ''
                if (this.minPrice && this.maxPrice) {
                    priceText = `${this.minPrice} - ${this.maxPrice}`
                } else if (this.minPrice) {
                    priceText = `${this.$t('search.from')} ${this.minPrice}`
                } else if (this.maxPrice) {
                    priceText = `${this.$t('search.to')} ${this.maxPrice}`
                }
                
                if (priceText) {
                    selectedPrices.push({
                        id: 'price_range',
                        name: priceText,
                        type: 'price'
                    })
                }
            }
            
            return selectedPrices
        },
        selectedSpaces() {
            const selectedSpaces = []
            
            if (this.minSpace || this.maxSpace) {
                let spaceText = ''
                if (this.minSpace && this.maxSpace) {
                    spaceText = `${this.minSpace} - ${this.maxSpace}`
                } else if (this.minSpace) {
                    spaceText = `${this.$t('search.from')} ${this.minSpace}`
                } else if (this.maxSpace) {
                    spaceText = `${this.$t('search.to')} ${this.maxSpace}`
                }
                
                if (spaceText) {
                    selectedSpaces.push({
                        id: 'space_range',
                        name: spaceText,
                        type: 'space'
                    })
                }
            }
            
            return selectedSpaces
        }
    },
    watch: {
        priceState: {
            handler(newVal) {
                this.localPrice = { ...newVal }
            },
            deep: true
        },
        spacesState: {
            handler(newVal) {
                this.localSpaces = { ...newVal }
            },
            deep: true
        }
    },
    methods: {
        togglePriceState() {
            this.priceDropdownOpen = !this.priceDropdownOpen
        },
        toggleSpacesState() {
            this.spacesDropdownOpen = !this.spacesDropdownOpen
        },
        submitPriceRange() {
            if (this.localPrice.min_price.val >= this.localPrice.max_price.val && this.localPrice.min_price.val != "" && !this.localPrice.max_price.val) {
                this.localPrice.isErr = true
                return
            } else {
                this.localPrice.isErr = false
                this.$emit('price-submitted', {
                    min: this.localPrice.min_price.val,
                    max: this.localPrice.max_price.val
                })
            }
        },
        submitSpaceRange() {
            if (this.localSpaces.min_space.val >= this.localSpaces.max_space.val && this.localSpaces.min_space.val != "" && !this.localSpaces.max_space.val) {
                this.localSpaces.isErr = true
                return
            } else {
                this.localSpaces.isErr = false
                this.$emit('spaces-submitted', {
                    min: this.localSpaces.min_space.val,
                    max: this.localSpaces.max_space.val
                })
            }
        },
        updateNegotiable(val) {
            this.$emit('negotiable-changed', val)
        },
        removePriceRange() {
            this.localPrice.min_price.val = ''
            this.localPrice.max_price.val = ''
            this.localPrice.isErr = false
            this.$emit('remove-price')
        },
        removeSpaceRange() {
            this.localSpaces.min_space.val = ''
            this.localSpaces.max_space.val = ''
            this.localSpaces.isErr = false
            this.$emit('remove-space')
        }
    }
}
</script>

<style scoped>
.transition-height-transform {
    transition-property: min-height, transform;
    transition-duration: 300ms;
    transition-timing-function: ease-in-out;
}
</style>

